<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            View {{ discountName }} members
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div>
          <div class="flex justify-between items-center mt-[16px]">
            <span class="text-[#353535] text-[14px] font-medium leading-[20px]"
              >All members currently linked to {{ discountName }}</span
            >
            <button
              v-if="hasPermission('Discount_Create_Members')"
              @click="viewAddMember"
              class="text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[12px] px-[24px] rounded-[8px] bg-[#2463Eb] border-b-[1.5px] border-[#2463EB] text-[#fff] max-w-max"
            >
              Add Member
            </button>
          </div>
        </div>
        <div
          class="bg-white rounded-[4px] flex items-center gap-[16px] mt-[16px]"
        >
          <div class="table-responsive">
            <table class="table m-0 p-0 text-nowrap">
              <thead class="bg-[#ECF9FF]">
                <tr>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Name
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Member Type
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Joined
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr v-for="m in members" :key="m.id">
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ m.memberName }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ m.type }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ formatDate(m.joined) }}
                  </td>
                  <td>
                    <span
                      v-if="hasPermission('Discount_Remove_Members')"
                      class="cursor-pointer text-[#DC2828] font-medium text-[14px] leading-[16.94px]"
                      @click.prevent="remove(m.id)"
                    >
                      Remove
                    </span>
                  </td>
                </tr>
                <tr v-if="!members.length">
                  <td colspan="4">
                    <div class="text-center">No members</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade py-1" id="mod-add-member" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Add new members
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Member Type</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  placeholder="Select an option"
                  v-model="newMember.type"
                >
                  <option v-for="type in types" :key="type" :value="type">{{
                    type
                  }}</option>
                </select>
                <ul v-if="v1.type" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="pb-[16px]">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Member Name</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full Outline-none focus:outline-none"
                  placeholder="Select an option"
                  v-model="newMember.memberId"
                >
                  <option v-for="m in newMembers" :key="m.id" :value="m.id">{{
                    m.text
                  }}</option>
                </select>
                <ul v-if="v1.memberId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="add"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";

export default {
  props: ["closeModal", "discountId"],
  mixins: [SystemPermissions.Mixin],
  name: "settingsDiscountMembers",
  components: {
    Select2,
    Pagination,
  },
  created() {
    // if (!this.hasPermission("Discount_View_Members")) {
    //   this.$router.push("/restricted");
    // }
    // this.discountId = this.$route.params.id;
    this.getDiscount();
    this.getMembers();
    this.getTypes();
  },
  data() {
    return {
      discountName: "",
      isBusy: false,
      isBusyModal: false,
      newMember: {
        memberId: null,
        type: null,
        discountId: null,
      },
      v1: {
        memberId: false,
        type: false,
      },
      members: [],
      types: [],
      newMembers: [],
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  watch: {
    "newMember.type": function(newVal, oldVal) {
      this.onTypeChange(newVal);
    },
  },
  methods: {
    viewAddMember() {
      this.newMember = {
        memberId: null,
        type: null,
        discountId: this.discountId,
      };
      this.v1 = {
        memberId: false,
        type: false,
      };

      $("#mod-add-member").modal("show");
    },
    add() {
      this.isBusyModal = true;
      this.isBusy = true;

      if (this.validate()) {
        $("#mod-add-member").modal("hide");

        this.$http
          .post("/Discounts/addMember", this.newMember)
          .then(function(res) {
            this.isBusyModal = false;
            this.getMembers();
          })
          .catch(function() {
            this.isBusyModal = false;
            this.isBusy = false;
          });
      } else {
        this.isBusyModal = false;
        this.isBusy = false;
      }
    },
    validate() {
      this.v1 = {
        memberId: false,
        type: false,
      };
      var isValid = true;

      if (!this.newMember.memberId) {
        this.v1.memberId = true;
        isValid = false;
      }

      if (!this.newMember.type) {
        this.v1.type = true;
        isValid = false;
      }

      return isValid;
    },
    remove(id) {
      this.isBusy = true;

      this.$http
        .delete("/Discounts/deleteMember/" + id)
        .then(function(res) {
          this.isBusy = false;
          this.getMembers();
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    getDiscount() {
      this.isBusy = true;

      this.$http
        .get("/Discounts/getById/" + this.discountId)
        .then(function(res) {
          this.discountName = res.body.name;
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    getMembers() {
      this.isBusy = true;

      this.$http
        .get("/Discounts/getMembers/" + this.discountId)
        .then(function(res) {
          this.members = res.body;
          this.isBusy = false;
        })
        .catch(function() {
          this.isBusy = false;
        });
    },
    getTypes() {
      this.types = ["Group", "Customer"];
    },
    onTypeChange(type) {
      this.newMembers = [];
      this.newMember.memberId = "";

      if (type) {
        switch (type) {
          case "Group":
            this.isBusyModal = true;

            this.$http
              .get("/Groups/getItemList/" + this.user.parentId)
              .then(function(res) {
                this.newMembers = res.body;
                this.isBusyModal = false;
              })
              .catch(function() {
                this.isBusyModal = false;
              });
            break;
          case "Merchant":
            this.isBusyModal = true;

            this.$http
              .get(
                "/Accounts/getItemList?parentId=" +
                  this.user.parentId +
                  "&accountType=" +
                  this.user.type
              )
              .then(function(res) {
                this.newMembers = res.body;
                this.isBusyModal = false;
              })
              .catch(function() {
                this.isBusyModal = false;
              });
            break;
          case "Customer":
            this.isBusyModal = true;

            this.$http
              .get("/Users/getItemListOfCustomers/" + this.user.parentId)
              .then(function(res) {
                this.newMembers = res.body;
                this.isBusyModal = false;
              })
              .catch(function() {
                this.isBusyModal = false;
              });
            break;
          default:
            break;
        }
      }
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
  },
};
</script>

<style></style>
